import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    DamageStatus,
} from 'app/enums/label.enums'
import {
    Damage,
} from './Damages.types'

const config: SkyNetTableConfig<keyof Damage> = {
    name: 'Damages',
    tabs: [{
        name: 'All Damages',
        url: 'all',
        fields: [
            {
                name: 'damageNumber',
                reduced: true,
                labelKey: 'DAMAGE_NUMBER',
            },
            {
                name: 'serialNumber',
                reduced: true,
                labelKey: 'CONTAINER_SERIAL_NUMBER',
            },
            {
                name: 'containerModel',
                filterField: 'containerModel',
                filterType: FilterType.Array,
                reduced: true,
                labelKey: 'CONTAINER_MODEL',
            },
            {
                name: 'reportedOn',
                componentName: 'DateTimeCell',
                labelKey: 'REPORTED_ON_UTC',
            },
            {
                name: 'causingOrder',
                filterField: 'causingOrder',
                filterType: FilterType.Array,
                labelKey: 'CAUSING_ORDER',
            },
            {
                name: 'linkedPriorDamageNumber',
                filterField: 'linkedPriorDamageNumber',
                filterType: FilterType.Array,
                labelKey: 'LINKED_PRIOR_DAMAGE',
            },
            {
                name: 'damageTypeName',
                filterField: 'damageTypeName',
                filterType: FilterType.Array,
                labelKey: 'DAMAGE_TYPE',
            },
            {
                name: 'damageStatus',
                filterField: 'damageStatus',
                filterType: FilterType.Array,
                allowedValuesEnum: DamageStatus,
                componentName: 'EnumValue',
                labelKey: 'STATUS',
            },
            {
                name: 'repairingServiceCenter',
                filterField: 'repairingServiceCenter',
                filterType: FilterType.Array,
                labelKey: 'REPAIRING_SERVICE_CENTER',
            },
            {
                name: 'repairedOn',
                componentName: 'DateTimeCell',
                labelKey: 'REPAIRED_ON_UTC',
            },
            {
                name: 'repairedBy',
                filterField: 'repairedBy',
                filterType: FilterType.Array,
                labelKey: 'REPAIRED_BY',
            },
        ],
    }],
}

export default config
